<template>
  <div :class="['coordenada-card', { 'notValid': !isValid }]">

    <DxValidator ref="validadorCoordenadasFirma">
      <DxAdapter :get-value="cumpleRequisito" />
      <DxRequiredRule :message="$t('coordenadas_firma.mensaje_requerida')" />
    </DxValidator>

    <!-- Cabecera de la tarjeta -->
    <div class="card-header position-relative">
      <div class="fs-6 fw-bold text-success w-100">
        {{ $t('coordenadas_firma.titulo') }}
      </div>
    </div>

    <!-- Cuerpo de la tarjeta -->
    <div class="card-body">
      <div v-for="(coordenadaFirma, index) in model" class="coordenada-container" :key="index">
        <div class="coord-field">
          <div class="dx-field-item-label-text">{{ $t('coordenadas_firma.pagina') }}</div>
          <div class="dx-field-value">
            <DxNumberBox v-model:value="coordenadaFirma.Pagina" :min="1" format="#" :show-spin-buttons="true"
              :read-only="readOnly" />
          </div>
        </div>
        <div class="coord-field">
          <div class="dx-field-item-label-text">{{ $t('coordenadas_firma.x') }}</div>
          <div class="dx-field-value">
            <DxNumberBox v-model:value="coordenadaFirma.X" :min="0" format="#" :show-spin-buttons="true" :read-only="readOnly" />
          </div>
        </div>
        <div class="coord-field">
          <div class="dx-field-item-label-text">{{ $t('coordenadas_firma.y') }}</div>
          <div class="dx-field-value">
            <DxNumberBox v-model:value="coordenadaFirma.Y" :min="0" format="#" :show-spin-buttons="true" :read-only="readOnly" />
          </div>
        </div>
        <div v-if="!readOnly" class="align-self-end py-1">
          <i @click="deleteCoordenada(coordenadaFirma)" class="fa-regular fa-trash fa-lg text-danger" role="button"></i>
        </div>
      </div>
      <DxButton :width="200" icon="plus" :text="$t('coordenadas_firma.agregar_coordenada')" :button-options="{...primaryButtonProps}" @click="addCoordenada()" v-if="!readOnly" />
    </div>
    <div class="d-flex">
      <div v-if="!isValid" class="required-icon">
        <i class="fa-solid fa-circle-exclamation"></i>
      </div>
      <div v-if="!isValid" class="dx-invalid-message fw-bold">
        {{ $t('coordenadas_firma.mensaje_requerida') }}
      </div>
    </div>
  </div>

</template>


<script setup lang="ts">
import type { CoordenadaFirma } from '@api/api';
import DxValidator, { DxRequiredRule, DxAdapter } from 'devextreme-vue/validator';
import { ref } from 'vue';
import { DxButton } from 'devextreme-vue/button';
import { DatosCoordenadaFirma } from '@/components/coordenadas-firma/models/DatosCoordenadaFirma';
import { DxNumberBox } from 'devextreme-vue';
import { primaryButtonProps } from '@/.shared/helpers/button-helper';

const props = defineProps({
  model: Object as () => CoordenadaFirma[],
  documentoAsociado: String,
  readOnly: Boolean
});

const isValid = ref(true);
const validadorCoordenadasFirma = ref();

const emit = defineEmits(["update:model"]);

const cumpleRequisito = () => {
  return props.model && props.model?.length > 0;
};

function addCoordenada() {
  props.model?.push(new DatosCoordenadaFirma());
  validate();
}

function deleteCoordenada(c: CoordenadaFirma) {
  if (!props.model || !props.model) return;

  emit("update:model", props.model.filter(elem => elem !== c));
  validate();
}

const validate = async () => {
  if (validadorCoordenadasFirma.value.instance) {
    const result = await validadorCoordenadasFirma.value.instance?.validate();
    isValid.value = result.isValid;
    return result;
  }
  return Promise.resolve({ isValid: true });
}

defineExpose({ validate });

</script>

<style lang="scss" scoped>


.coordenada-card {
  border: 1px solid var(--border-default-default);
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  width: 100%;
  flex: 0 0 auto;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
}

.card-header {
  padding: 1rem 1rem;
  text-align: left;
  flex: 0 0 auto;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}

.card-body {
  padding: 0 1rem 1rem;
  flex: 1 1 auto;
  overflow: auto;
  display: flex;
  flex-direction: column;
  height: 100%;
}

.coordenada-container {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
}

.coordenada-container .coord-field {
  display: flex;
  flex-direction: column;
}

.coord-field .dx-field-value:not(.dx-switch):not(.dx-checkbox):not(.dx-button) {
  width: 85%;
}

.info-icon {
  margin-left: auto;
  font-size: 20px;
  cursor: pointer;
  position: relative;
}

.required-icon {
  margin-left: 5px;
  font-size: 20px;
  cursor: pointer;
  position: relative;
  color: var(--text-error-default);
}

.tooltip {
  position: absolute;
  top: 100%;
  right: 0;
  background-color: var(--background-normal-dark);
  color: var(--text-default-inverse);
  padding: 5px;
  border-radius: 4px;
  white-space: nowrap;
  font-size: 12px;
  z-index: 1000000;
  margin-top: 5px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.requerido-tag {
  background: var(--background-primary-default);
}

.notValid {
  border: 3px solid var(--border-error-default);

  .requerido-tag {
    background: var(--background-error-default);
  }
}

.dx-invalid-message {
  display: block;
  margin: 5px 10px;
  color: var(--text-error-default);
  font-size: 12px;
}
</style>